// Product-info.js

function selectSwatch(colorSwatch) {
  console.log({ colorSwatch });
  colorSwatch.classList.add("color-swatch__selected");
  const type = document.querySelector(
      `#${colorSwatch.getAttribute("for")}`
  ).value;
  const mount = colorSwatch
      .closest(".product-info__block-item")
      .getElementsByClassName("mount")[0];
  // If is mount is hidden in swatch.liquid, set hiddenMount true;
  const hiddenMount = mount.className.includes("hidden");
  // if hidden is true do the logic of mount
  if (!hiddenMount)
    if (type == "Unframed") {
      mount.style.display = "none";
    } else {
      mount.style.display = "block";
    }

  // Timeout for wait until page loaded
  setTimeout(() => {
    colorSwatch.click();
  }, 35);
}

function forceSelectSwatch() {
  const colorSwatches = document.querySelectorAll(".color-swatch:not(.is-disabled)");
  const selectedSwatches = [...colorSwatches].filter(_ => _.classList.contains("color-swatch__selected"));

  if (selectedSwatches.length === 0) {
    console.log(colorSwatches, colorSwatches[0])
    colorSwatches[0]?.click();
  }
}

const initColorSwatches = (el = null, quickBuy = false) => {
  if (!el) return;

  const allColorSwatches = el.querySelectorAll(".color-swatch");
  const colorSwatches = el.querySelectorAll(".color-swatch:not(.is-disabled)");
  console.log({colorSwatches})
  // Add click event listener to each color swatch
  //data-option-name="Size"
  let hiddenMount = false, hiddenColor = false;

  colorSwatches.forEach((colorSwatch, index) => {
    // If is only one switch hide it
    if (allColorSwatches.length > 1) {
      let type = "";
      const initSelected = () => {
        // colorSwatch.classList.add("color-swatch__selected");
        type = document.querySelector(
          `#${colorSwatch.getAttribute("for")}`
        ).value;
        const mount = colorSwatch
          .closest(".product-info__block-item")
          .getElementsByClassName("mount")[0];

        const frame = colorSwatch
            .closest(".product-info__block-item")
            .getElementsByClassName("variant-picker__option-frame")[0];

        if (frame)
          frame.innerText = `Frame: ${colorSwatch.getAttribute("data-tooltip")}`;

        // If is mount is hidden in swatch.liquid, set hiddenMount true;
        hiddenMount = mount.className.includes("hidden");
        // if hidden is true do the logic of mount
        if (!hiddenMount)
          if (type == "Unframed") {
            mount.style.display = "none";
          } else {
            mount.style.display = "block";
          }

        // Timeout for wait until page loaded
        setTimeout(() => {
          colorSwatch.click();
        }, 35);
      };

      if (colorSwatch.classList.contains("color-swatch__selected")) {
        initSelected();
      }

      colorSwatch.onclick = () => {
        // Remove 'color-swatch__selected' class from all color swatches
        colorSwatches.forEach((sw) => {
          sw.classList.remove("color-swatch__selected");
        });

        // Add 'color-swatch__selected' class to the clicked color swatch
        colorSwatch.classList.add("color-swatch__selected");
        const mount = colorSwatch
          .closest(".product-info__block-item")
          .getElementsByClassName("mount")[0];

        const frame = colorSwatch
          .closest(".product-info__block-item")
          .getElementsByClassName("variant-picker__option-frame")[0];

        frame.innerText = `Frame: ${colorSwatch.getAttribute("data-tooltip")}`;

        //variant-picker__option-frame

        type = document.querySelector(
          `#${colorSwatch.getAttribute("for")}`
        ).value;

        let counter = 0;
        let last = "";
        Array.from(
          mount.parentNode.parentNode.parentNode.querySelector(
            "[data-option-selector]"
          ).children
        ).forEach((child) => {
          if (child.tagName === "LABEL" && !child.innerText.includes("N/A")) {
            counter++;
            last = child;
          }
        });

        if (counter === 1) {
          mount.innerText = `Mount: ${last.innerText}`;
          last.classList.add("hidden");
        } else if (counter > 1) {
          mount.innerText = "Mount: ";
        }

        if (!hiddenMount)
          if (type == "Unframed") {
            mount.style.display = "none";
          } else {
            mount.style.display = "block";
          }
      };

    } else {
      hiddenColor = true;
      colorSwatch.classList.add("hidden");
    }
    // If is disabled set gap for variant picker 0rem
    if (hiddenColor && !hiddenMount) {
      //document.querySelector('.variant-picker').style.gap = '0rem'
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  (() => {
    const showChar = 370;
    const ellipsestext = "...";
    document.querySelectorAll(".truncate-description").forEach((el) => {
      const content = el.innerHTML;
      if (content.length > showChar) {
        const c = content.substr(0, showChar);
        const h = content;
        const html =
          '<div class="truncate-text" style="display:block">' +
          c +
          '<span class="moreellipses" style="display: unset;">&nbsp;&nbsp;' +
          ellipsestext +
          '<a class="_ml more"><u>(more)</u></a></span></span></div><div class="truncate-text" style="display:none">' +
          h +
          '<a class="_ml less"><u>less</u></a></span></div>';

        el.innerHTML = html;
      }
    });

    document.querySelectorAll("._ml").forEach((el) => {
      el.onclick = (event) => {
        const thisEl = event.target.parentNode;
        const cT = thisEl.closest(".truncate-text");
        const tD = thisEl.closest(".truncate-description");
        const [display0, display1] = thisEl.className.includes("more")
          ? ["none", "block"]
          : ["block", "none"];
        tD.children[1].style.display = display1;
        tD.children[0].style.display = display0;
        return false;
      };
    });
    // Color swatches
    initColorSwatches(
        document.querySelector('[data-block-type="variant-picker"]')
    );

    setTimeout(() => {
      forceSelectSwatch()
    }, 200 + Math.random());

    const bodyNode = document.querySelector("body");

    const bodyObserver = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          Array.from(mutation.addedNodes).forEach((el) => {
            if (el.localName === "quick-buy-modal") {
              el.querySelectorAll('[data-block-type="variant-picker"]').forEach(
                (block) => {
                  initColorSwatches(block, true);
                }
              );
            }
          });
        }
      }
    });

    bodyObserver.observe(bodyNode, { childList: true });

    const popupBack = document.querySelectorAll(".popup-back");
    popupBack.forEach((el) => {
      el.onclick = (ev) => {
        if (ev.target !== ev.currentTarget) return;

        ev.target.style.display =
          ev.target.style.display === "block" ? "none" : "block";
      };
    });
  })();

  const numberFormat = new Intl.NumberFormat("en-US", {});

  document.addEventListener("variant:change", function (event) {
    const salePrice = event.target
      .closest(".product-info__block-list")
      .querySelector("sale-price");
    if (salePrice) {
      const inputString = salePrice.innerText.replace("SALE PRICE\n", "");
      const currencyMatch = inputString.match(/[^\d.,]+/);

      const currency = currencyMatch ? currencyMatch[0].trim() : "";
      salePrice.innerText = `${currency} ${numberFormat.format(
        parseInt(`${event.detail.variant.price}`.slice(0, -2))
      )}`;
      console.log(event);
    }
    //color-swatch__selected

    forceSelectSwatch();
  });

  document.querySelectorAll("[data-more-trigger]").forEach((el) => {
    el.innerText =
      el.innnerText === el.dataset.moreTextMore
        ? el.dataset.moreTextLess
        : el.dataset.moreTextMore;
    el.onclick = (ev) => {
      ev.preventDefault();
      const parent = ev.target.closest("[data-more]");
      const content = parent.querySelector("[data-more-content]");

      content.classList.toggle("read-more-toggle");
      console.log(ev.target);
      ev.target.innerText =
        ev.target.innerText == ev.target.dataset.moreTextMore
          ? ev.target.dataset.moreTextLess
          : ev.target.dataset.moreTextMore;
    };
  });

  document
    .querySelectorAll("[data-more-content]")
    .forEach((el) => el.classList.add("read-more-toggle"));

  /* Screen reader */
  const bagBtn = document.querySelector('a[href="/cart"]');
  const cartStatus = document.querySelector("#cart-status");

  if (bagBtn) {
    bagBtn.addEventListener("click", () => {
      setTimeout(() => {
        cartStatus.textContent = `Your bag has ${window.cartItemsCount} items`;
        cartStatus.setAttribute("aria-live", "polite");
        cartStatus.setAttribute("role", "alert");
      }, 3000);
    });
  }
});

// print PDF function
function printDiv(divName) {
  var printContents = document.getElementById(divName).innerHTML;
  var originalContents = document.body.innerHTML;

  document.body.innerHTML = printContents;

  window.print();

  document.body.innerHTML = originalContents;
}

// custom quote block
